import React from "react";
import { FaUser, FaIdCard, FaGlobe, FaDollarSign, FaCheckCircle, FaTimesCircle, FaRegMinusSquare, FaStop } from "react-icons/fa";
import { NameScammed } from "./NameScammed";
import { FormateDate } from "./FormateDate";
import { getName } from 'country-list';
import { formatCurrency } from "./shared/formatCurrency";
import { useTranslation } from "react-i18next";

export const DetailedUserCard = ({ user }) => {
  const { t } = useTranslation();

  return (
    <div className="p-6 bg-gradient-to-r from-blue-50 to-blue-100 shadow-lg rounded-lg mx-auto mt-4">
      <div className="flex items-center mb-4">
        <FaIdCard className="text-blue-500 mr-2" />
        <h1 className="text-2xl font-bold text-blue-800">{user.first_name} {user.last_name}</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <p className="flex items-center text-lg font-semibold">
          <FaUser className="text-gray-600 mr-2" />
          {t('user_info.id')}: <span className="font-normal ml-1">{user.id}</span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          <span dangerouslySetInnerHTML={{ __html: t('user_info.p_scammed_by') }} />

          <span className="font-normal ml-1">
            <NameScammed user={user.children.filter(child => child.id === user.parent_id)[0]} />
          </span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          {t('user_info.verified')}:
          <span className={`font-normal ml-1 ${user.personal_data_verify === 1 ? "text-green-500" : "text-red-500"}`}>
            {user.personal_data_verify === 1 ? <FaCheckCircle /> : <FaTimesCircle />}
          </span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          <FaRegMinusSquare className="text-gray-600 mr-2" />
          {t('withdrawn')}: <span className="font-bold text-red-500 ml-1">{formatCurrency(user.withdrawn)}</span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          {t('user_info.total_r')}: <span className="font-normal ml-1">{user.total_ranks}</span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          {t('user_info.default_leg')}: <span className="font-normal ml-1">{user.default_leg}</span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          <FaStop className="text-gray-600 mr-2" />
          {t('invested')}: <span className="font-bold text-green-500 ml-1">{formatCurrency(user.invested)}</span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          {t('user_info.updated_at')}: <span className="font-normal ml-1"><FormateDate date={user.updated_at} /></span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          {t('user_info.user_type_id')}: <span className="font-normal ml-1">{user.user_types_id}</span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          <FaUser className="text-gray-600 mr-2" />
          {t('user_info.username')}: <span className="font-normal ml-1">{user.user_name}</span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          {t('user_info.global_capital')}: <span className="font-normal ml-1">{formatCurrency(user.global_capital_user)}</span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          {t('user_info.status')}:
          <span className={`font-normal ml-1 ${user.status === 1 ? "text-green-500" : "text-red-500"}`}>
            {user.status === 1 ? <FaCheckCircle /> : <FaTimesCircle />}
          </span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          <FaDollarSign className="text-gray-600 mr-2" />
          {t('user_info.personal_capital')}: <span className="font-normal ml-1">{formatCurrency(user.personal_capital_user)}</span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          {t('user_info.total_members')}: <span className="font-normal ml-1">{user.total_members}</span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          {t('user_info.total_members_btc_500')}: <span className="font-normal ml-1">{user.total_members_btc500}</span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          <FaGlobe className="text-gray-600 mr-2" />
          {t('user_info.country')}: <span className="font-normal ml-1">{user.country_code && getName(user.country_code)}</span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          {t('user_info.team_capital')}: <span className="font-normal ml-1">{formatCurrency(user.team_capital_user)}</span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          {t('user_info.total_members_btc_1000')}: <span className="font-normal ml-1">{user.total_members_btc1000}</span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          {t('user_info.registered_at')}: <span className="font-normal ml-1"><FormateDate date={user.created_at} /></span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          {t('user_info.pyramid_level')}: <span className="font-normal ml-1">{user.level}</span>
        </p>
        <p className="flex items-center text-lg font-semibold">
          {t('user_info.personal_data_set_by_admin')}:
          <span className={`font-normal ml-1 ${user.personal_data_set_by_admin === 1 ? "text-green-500" : "text-red-500"}`}>
            {user.personal_data_set_by_admin === 1 ? <FaCheckCircle /> : <FaTimesCircle />}
          </span>
        </p>
      </div>
    </div>
  );
};
